import React, { useState, useContext, useEffect, Suspense, lazy } from "react";
import { Card, Container, Row, Col, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RoleContext } from "../../RoleContext";

import cross from "../../components/Assests/Icons/cross1.webp";
import tick from "../../components/Assests/Icons/tick1.webp";
import phibroLogo from "../../components/Assests/Phibro-Tagline-Logo.png";
import loginPageImg from "../../components/Assests/Icons/login-page-back.webp";

import "./styles/preLogin.css";

import { signIn, getRole } from "../../services/signInApi";

// Lazy load modal component
const InvalidCredentialsModal = lazy(() => import("./components/InvalidCredentialsModal"));

const ROLE_ROUTES = {
  "Lab Admin": "/global-dashboard",
  "Field Staff": "/field-staff-dashboard",
  "Analyst": "/analyst-dashboard",
  "IT Admin": "/global-dashboard",
};

const PreLogin = () => {
  const [email, setEmail] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const { setRole, setRoleOptions } = useContext(RoleContext);
  const navigate = useNavigate();

  const handleCustomerClick = (isCustomer) => {
    if (isCustomer) {
      navigate("/customer-login");
    } else {
    }
  };

  const handleSignIn = async () => {
    try {
      localStorage.clear();
      const response = await signIn();   
      if (response?.success || response?.token) {
        const userData = await getRole(response?.token);

        localStorage.setItem("accessToken", response.token);
        localStorage.setItem("userData", JSON.stringify(userData));
        const { roleName, locations } = userData;
        const currentrole = localStorage.getItem("currentRole") || roleName[0] || "";
        localStorage.setItem("currentRole", JSON.stringify(currentrole));

        setRoleOptions(userData.roleName || []);
        setRole(userData.roleName && userData.roleName[0] ? userData.roleName[0] : "");
        if(roleName[0] === "Analyst"){
        const locationName = locations.map(ele => ele.locationName).join(",");
        localStorage.setItem("selectedLocationName", JSON.stringify(locationName)); 
        }
        if (rememberMe) {
          localStorage.setItem("userEmail", email);
        } else {
          localStorage.removeItem("userEmail");
        }

        const userRole = userData.roleName && userData.roleName[0] ? userData.roleName[0] : "";

        const targetRoute = ROLE_ROUTES[userRole];

        if (targetRoute) {
          navigate(targetRoute);
        } else {
          navigate("/global-dashboard");
        }
      } else {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Login error:", error);
      setShowModal(true);
    }
  };

  const handleTickIconFunctionality = () => {
    handleSignIn();
  };

  // Load saved email from localStorage
  useEffect(() => {
    const savedEmail = localStorage.getItem("userEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Navbar
        bg="white"
        className="px-3"
        style={{ borderBottom: "4px solid #0070c0", minHeight: 60 }}
      >
        <Navbar.Brand href="#" className="d-flex align-items-center gap-2">
          <img src={phibroLogo} alt="Phibro Logo" style={{ height: 40 }} loading="lazy" />
          <span style={{ fontWeight: 500, fontSize: 22, color: "#003087" }}>
            Feed Assay Portal
          </span>
        </Navbar.Brand>
      </Navbar>

      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: `url(${loginPageImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col xs={10} md={6} lg={4}>
              <Card className="text-center p-4 shadow-lg rounded-4">
                <Card.Body>
                  <Card.Title as="h4" className="mb-4 textStyle">
                    Are you a Customer?
                  </Card.Title>
                  <div className="d-flex justify-content-around">
                    <img
                      src={tick}
                      alt="tick"
                      width={50}
                      height={50}
                      loading="lazy"
                      className="hover-icon"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleCustomerClick(true)}
                    />
                    <img
                      src={cross}
                      alt="cross"
                      width={50}
                      height={50}
                      loading="lazy"
                      className="hover-icon"
                      style={{ cursor: "pointer" }}
                      onClick={handleTickIconFunctionality}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Navbar
        variant="dark"
        className="justify-content-center footer-style"
        style={{ minHeight: 40 }}
      >
        <span className="text-white" style={{ fontSize: 14 }}>
          © 2025 Phibro Animal Health Corporation. All rights reserved.
        </span>
      </Navbar>

      <Suspense fallback={<div>Loading...</div>}>
        <InvalidCredentialsModal show={showModal} onHide={() => setShowModal(false)} />
      </Suspense>
    </div>
  );
};

export default PreLogin;
